import { webAPI } from '../../../axiosInstance';


const getAllBrands = async () => {
  const response = await webAPI.get('/brands');
  return response.data;
};


const addBrand = async (data: any) => {
  console.log('data2333', data)
  const response = await webAPI.post('/brands', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

const deleteBrand = async (data: any) => {
  const response = await webAPI.delete(`/brands/delete/${data}`);
  return response.data;
};

export { getAllBrands, addBrand, deleteBrand };
